import React from 'react';

const ClassroomCardPlaceholder = () => (
  <div className="card-large placeholder">
    <a className="card-large-img">
      <img className="no-image" src="" alt="" />
      <div className="animated-background" style={{ marginTop: '25px', marginLeft: '16px' }} />
      <div className="animated-background" style={{ marginTop: '15px', marginLeft: '16px', width: '70%' }} />
      <div className="animated-background" style={{ marginTop: '20px', marginLeft: '16px', width: '35%' }} />
    </a>
  </div>
);

export default ClassroomCardPlaceholder;
